export const maxUploadFileSize = 2.097e+7; // 1e+7 = 10 MiB;// 5 MiB = 5242880; //2 MiB = 2097152;